import { PotentiallyUnsafeInnerHtml } from "@/components/potentially-unsafe-inner-html"
import { highlightSearch } from "@/lib/highlight-search"
import { cn } from "@/lib/utils"

// Keep this for backward compatibility. Please use HighlightedText
interface HighlightTextProps extends React.ComponentPropsWithoutRef<"span"> {
  text: string
  searchValue: string
  extendedMarkClasses?: string
  isHTMLText?: boolean
}

/**
 * @deprecated Please use HighlightedText
 */
export const HighlightText = ({
  text,
  searchValue,
  extendedMarkClasses,
  isHTMLText = false,
  className,
  ...props
}: HighlightTextProps) => {
  if (!searchValue)
    return isHTMLText ? (
      <PotentiallyUnsafeInnerHtml className={cn("inline", className)} value={text} {...props} />
    ) : (
      <span className={className} {...props}>
        {text}
      </span>
    )

  return (
    <PotentiallyUnsafeInnerHtml
      className={cn("inline", className)}
      value={highlightSearch(text, searchValue, extendedMarkClasses)}
      {...props}
    />
  )
}
